import { h, Fragment } from 'preact';

type CustomFileInputProps = {
  name: string;
  placeholder: string;
  label: string;
  validator?: string;
  preview?: string;
  isReview?: boolean;
};

import { FormState } from '../../../states/kyc-form-state';
import { useRef, useState } from 'preact/hooks';
import { useSignalEffect } from '@preact/signals';
import Visibility from '../../../components/visibility';
import { GlobalState } from '../../../states/global-state';
import { blobToUrl, showAlert } from '../../../utils';
import { getCustomerFile } from '../../../controllers/KycController';

import * as files from '../../../assets/files.json';

const CustomFileInput = (props: CustomFileInputProps) => {
  const [uploadedSrc, setUploadedSrc] = useState('');
  const [src, setSrc] = useState('');
  const [hasFile, setHasFile] = useState(false);
  const [isTempChange, setIsTempChange] = useState(false);
  const inputRef = useRef();

  useSignalEffect(() => {
    const blobUrl =
      FormState.formControlValues[`blob-url-${props.name}`]['value'];

    if (blobUrl) {
      setSrc(blobUrl);
      setUploadedSrc(blobUrl);
      setIsTempChange(false);
      setHasFile(true);
      reset(inputRef);
    }
  });

  const onChangeHandler = e => {
    const file = e.target.files[0];

    if (file) {
      const test =
        ['image', 'pdf'].some(item => file.type.includes(item)) &&
        file.size <= 1024 * 1024 * 10;

      if (test) {
        const url = blobToUrl(file);
        setSrc(url);

        if (uploadedSrc) {
          setIsTempChange(true);
        }
      } else {
        showAlert({
          title: 'File Error',
          text: 'file is not allowed',
          icon: 'error',
          allowOutsideClick: false,
        }).then(() => {
          reset(inputRef);
        });
      }
    }
  };

  const undoHandler = e => {
    setSrc(uploadedSrc);
    setIsTempChange(false);
    reset(inputRef);
  };

  return (
    <>
      <div class="mb-3 form-group">
        <label for={props.name}>{props.label}</label>
        <input
          type="file"
          class="form-control input"
          data-validator={hasFile && !isTempChange ? '' : props.validator || ''}
          id={hasFile && !isTempChange ? '' : props.name}
          name={hasFile && !isTempChange ? '' : props.name}
          placeholder={props.placeholder}
          onChange={onChangeHandler}
          ref={inputRef}
        />
        {/* store the file key if there is previously uploaded one */}
        {/* <Visibility condition={hasFile && !isTempChange}>
          <input
            type="hidden"
            name={props.name}
            id={props.name}
            value={fileKey}
          />
        </Visibility> */}
      </div>

      <Visibility condition={isTempChange}>
        <p class="bg-info p-1">
          Uploading a new file will replace the previous uploaded one.
        </p>
      </Visibility>

      <div class="preview-container">
        <Visibility condition={isTempChange}>
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              onClick={undoHandler}
            />
          </div>
        </Visibility>

        <img
          src={src}
          style={{ width: '100%' }}
          alt="preview"
          onLoad={e => {
            const target = e.target as unknown as HTMLImageElement;
            target.style.display = 'inline-block';

            if (!target.src.includes('/assets/icons/pdf.png')) {
              target.style.width = '100%';
            }
          }}
          onError={e => {
            const target = e.target as unknown as HTMLImageElement;
            if (props.isReview) {
              target.style.width = '40px';
              target.src = files.pdf;
              target.dataset.fromError = 'true';

              if (!target['hasEvent'] && src) {
                target.addEventListener('click', e => {
                  const a = document.createElement('a');
                  console.log(144, src);
                  a.href = src;
                  a.target = '_blank';
                  // a.download = 'preview';
                  a.click();
                });

                target['hasEvent'] = true;
              }
            } else {
              target.style.display = 'none';
            }
          }}
        />
      </div>
      <br />
    </>
  );
};

const reset = function (inputRef) {
  const input: HTMLInputElement = inputRef.current;

  if (input) {
    input.value = '';
  }
};

export default CustomFileInput;
